import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { GeoPoliticalEntity, Well, Wellbore, WellsMaster } from '../models/osdu';
import { APIResponse } from '../models/APIResponse';
import { apiV1 } from '../common/texts-constants';




@Injectable({
  providedIn: 'root'
})
export class OsduService {
  private http = inject(HttpClient);

  private apiBaseUrl = environment.apiUrl+apiV1;

  
  GetGeoPoliticalEntities(): Observable<{ message: string; count: number; data: GeoPoliticalEntity[] }> {
    return this.http.get<{ message: string; count: number; data: GeoPoliticalEntity[] }>(
      `${this.apiBaseUrl}Osdu/GeoPoliticalEntity`
    );
  }

  GetWellsByCountry(geoPoliticalEntityId: string): Observable<{ data: Well[] }> {
    return this.http.get<Well[]>(
      `${this.apiBaseUrl}Osdu/wellsData/${geoPoliticalEntityId}`
    ).pipe(
      map(wells => ({ data: wells }))  
    );
  }

  GetWellsByProjectId(ProjectId: number): Observable<APIResponse<WellsMaster[]>> {
    return this.http.get<APIResponse<WellsMaster[]>>(
      `${this.apiBaseUrl}WellsMaster/GetWellMaster/${ProjectId}`
    ).pipe(
      map(wells => wells)  
    );
  }

  GetWellsByRegion(region: string): Observable<APIResponse<WellsMaster[]>> {
    return this.http.get<APIResponse<WellsMaster[]>>(
      `${this.apiBaseUrl}WellsMaster/GetWellMaster?region=${region}`
    ).pipe(
      map(wells => wells)  
    );
  }


  GetWellboresByWellId(wellId: string): Observable<{ message: string; count: number; data: Wellbore[] }> {
    return this.http.get<{ message: string; count: number; data: Wellbore[] }>(
      `${this.apiBaseUrl}Osdu/wellbores/${wellId}`
    );
  }
}
